<template>
  <div>
    <div class="">
      <div class="alert alert-secondary alert-dark mt-3" v-if="!loading && results.length < 1">
        <span>Sorry! no record found for your query</span>
      </div>
      <div class="row py-5">
        <div class="col-12 col-sm-6" v-for="(result, k) in results" :key='k'>
          <div class="posterbox row">
            <figure class="posterimage col-12 col-lg-6 pr-lg-0 mb-0">
              <a href="#" @click.prevent="''">
                <span class="img" :style="`background-image: url(https://image.tmdb.org/t/p/w500/${result.poster_path || result.backdrop_path})`"></span>
              </a>
            </figure>
            <div class="col-12 col-lg-6 pl-lg-0">
              <div class="posterinfo h-100">
                <div class="postertitle">
                  <a href="#" @click.prevent="''">
                    <h3>
                      {{ result.title }}
                    </h3>
                  </a>
                </div>
                <div class="description">
                  <p>
                    {{ result.overview }}
                  </p>
                </div>
                <div class="moreinfo-area">
                  <a href="#" @click.prevent="''">More Info</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <span v-if='loading' class='show-more-loader'></span>
          <div v-if='noMoreResults && results.length >= 1' class="alert alert-secondary alert-dark mt-3">
            <span>No more results</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authRequest } from '../../app/helpers';

export default {
  data(){
    return {
      year: null,
      sort: null,
      inTheatre: false,
      results: [],
      loading: false,
      page: 1,
      noMoreResults: false,
    }
  },


  mounted() {
    this.setQuery().fetch();
    this.scroll();
  },

  methods: {
    async fetch() {
      const {
        loading, year, sort, 
        inTheatre, page, $router, 
        results, noMoreResults
      } = this;

      if (loading || noMoreResults) return;

      this.loading = true;

      const query = `?type=tv&year=${year}&sort=${sort}` 
        + `&in-theatre=${inTheatre}&page=${page}`;
      const req = await authRequest($router, '/discovery' + query);

      if (!req.results.length) {
        this.noMoreResults = true;
        this.loading = false;
        return;
      }

      this.results = [...results, ...req.results];
      this.loading = false;
    },


    setQuery() {
      const { query } = this.$route;

      this.year = query.year || '';
      this.sort = query.sort || '';
      this.inTheatre = query.inTheatre || '';

      return this;
    },

    scroll () {
      window.onscroll = () => {
        if ( !(this.$route.name == 'discover.shows') ) return;

        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight 
          === document.documentElement.offsetHeight;

        if (bottomOfWindow && !this.loading) {
          this.page += 1;
          this.fetch();
        }
      };
    },
  },

  watch: {
    $route() {
      this.setQuery().fetch();
    },
  }
};
</script>


<style lang="scss">
.discover-page-filter {
  label {
    color: white;
    text-transform: uppercase;
    font-size: 14px;
  }
}
.show-more-loader {
  background-image: url('../../assets/Ripple-1.2s-187px.svg');
  display: block;
  height: 70px;
  background-size: 95px;
  background-repeat: no-repeat;
  background-position: center;
}
</style>